/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventSceneManagementUploadEventImageResponse } from './EventSceneManagementUploadEventImageResponse';

export type EventSceneManagementUploadEventImageResponseApiRespoonse = {
    data?: EventSceneManagementUploadEventImageResponse;
    status?: EventSceneManagementUploadEventImageResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventSceneManagementUploadEventImageResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

